import { Alert, Autocomplete, AutocompleteProps, Box, TextField, TextFieldProps, Typography } from '@mui/material'
import { useState } from 'react'
import { useBulkPaymentStepperContext } from '../../contexts/BulkPaymentStepperContext'
import { NameWithFavicon } from '../NameWithFavicon'

type TVendorSelectProps = {
  sx?: AutocompleteProps<unknown, false, true, false>['sx']
  textFieldProps?: Omit<TextFieldProps, 'value' | 'onChange'>
}
export default function VendorSelect(props: TVendorSelectProps) {
  const { textFieldProps = {} } = props
  const { vendors, vendor, setVendorId } = useBulkPaymentStepperContext()
  const [inputValue, setInputValue] = useState('')

  if (!vendors) {
    console.error('vendors is undefined')
    return null
  }
  if (vendors.length === 0) {
    return <Alert severity="warning">No vendors found</Alert>
  }

  return (
    <Autocomplete
      autoSelect
      disablePortal
      disableClearable
      value={(vendor || null) as (typeof vendors)[0]}
      inputValue={inputValue}
      onInputChange={(e, value) => setInputValue(value)}
      options={vendors}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(e, value) => {
        setVendorId(value.id)
      }}
      renderInput={(params) => <TextField {...textFieldProps} {...params} value={vendor?.name || ''} label="Project" />}
      renderOption={(props, option) => {
        if (!option) return null
        const { key, ...optionProps } = props
        return (
          <li {...(optionProps as any)} key={option.id}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <NameWithFavicon name={option.name} website={option.website} />
              <Typography variant="caption" color="text.secondary">
                Outstanding: {option.outstandingCommission}
              </Typography>
            </Box>
          </li>
        )
      }}
      sx={{
        minWidth: 200,
        ...(props.sx || {}),
      }}
    />
  )
}
